import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT } from '../constants/common';

dayjs.extend(utc);
dayjs.extend(timezone);

export function isPastDate(date, timezone) {
  const nowInTZ = dayjs().tz(timezone);
  const eventEndInTZ = dayjs(date).tz(timezone);

  return eventEndInTZ.isBefore(nowInTZ);
}

export const getOffset = (timeZone = 'UTC', date = new Date()) => {
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
};

export const formatDate = date => {
  return date ? dayjs(date).format(DATE_FORMAT.DATETIME) : null;
};

export const formatDateDifference = (startDate, params = {}) => {
  if (!startDate) return '';

  const start = dayjs(startDate);
  const end = dayjs();

  const years = end.diff(start, 'years');
  const startPlusYears = start.add(years, 'years');

  const months = end.diff(startPlusYears, 'months');
  const startPlusYearsAndMonths = startPlusYears.add(months, 'months');

  const days = end.diff(startPlusYearsAndMonths, 'days');
  const startPlusYMD = startPlusYearsAndMonths.add(days, 'day');

  const hours = end.diff(startPlusYMD, 'hour');
  const startPlusYMDH = startPlusYMD.add(hours, 'hour');

  const minutes = end.diff(startPlusYMDH, 'minute');

  const resultParts = [`${years}y`, `${months}m`, `${days}d`];

  if (params.includeHours) {
    resultParts.push(`${hours}h`);
  }

  if (params.includeMinutes) {
    resultParts.push(`${minutes}m`);
  }

  return resultParts.join(' ');
};

export const disablePastTime = (current, minDate) => {
  if (!current) return {};
  if (!current.isSame(minDate, 'day')) return {};

  return {
    disabledHours: () => Array.from({ length: 24 }, (_, i) => i).filter(h => h < minDate?.hour()),

    disabledMinutes: () =>
      current.hour() === minDate?.hour()
        ? Array.from({ length: 60 }, (_, i) => i).filter(m => m < minDate?.minute())
        : [],

    disabledSeconds: () =>
      current.hour() === minDate?.hour() && current.minute() === minDate?.minute()
        ? Array.from({ length: 60 }, (_, i) => i).filter(s => s < minDate?.second())
        : []
  };
};
